import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useEffect, useState } from 'react';
import api from '../api';

function Header() {
  const { user, isAdmin, logout } = useAuth();
  const [siteName, setSiteName] = useState('Wedding Attire');

  useEffect(() => {
    api.get('/api/settings/public')
      .then(res => {
        if (res.data.site_name) {
          setSiteName(res.data.site_name);
        }
      })
      .catch(err => console.error('Failed to fetch site settings:', err));
  }, []);

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <img
            src="/images/logo.jpg"
            alt={siteName}
            className="logo-image"
          />
        </Link>
        <nav className="nav">
          <Link to="/">Início</Link>
          <Link to="/news">Novidades</Link>
          <Link to="/contact">Contacto</Link>
          {isAdmin && <Link to="/admin">Admin</Link>}
          {user ? (
            <button onClick={logout} className="btn btn-small btn-secondary">
              Sair
            </button>
          ) : (
            <Link to="/login" className="btn btn-small btn-primary">Login</Link>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
